module.exports = __webpack_public_path__ + "media/Elevate-Wellness-Video.49278c1d.mp4";